'use client';

import { useState } from 'react';
import { Pagination } from 'antd';

import { CampaignListProps } from './types';

import { CampaignsListItem } from './components';

const PAGE_SIZE = 10;

export const CampaignList = ({ campaigns }: CampaignListProps) => {
  const [currentPage, setCurrentPage] = useState<number>(1);

  // Calculate current campaigns to display based on pagination
  const indexOfLastCampaign = currentPage * PAGE_SIZE;
  const indexOfFirstCampaign = indexOfLastCampaign - PAGE_SIZE;
  const currentCampaigns = campaigns.slice(indexOfFirstCampaign, indexOfLastCampaign);

  // Calculate total number of pages
  const totalPages = Math.ceil(campaigns.length / PAGE_SIZE);

  const handlePageChange = (page: number): void => {
    setCurrentPage(page);
  };

  return (
    <div>
      {currentCampaigns.map((campaign) => (
        <CampaignsListItem key={campaign.id} campaign={campaign} />
      ))}

      {/* Отображаем пагинацию только если страниц больше 2 */}
      {totalPages > 2 && (
        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Pagination
            current={currentPage}
            total={campaigns.length}
            pageSize={PAGE_SIZE}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};
